import { defaultApiState } from '../api.state';

export const purchaseState = {
  apiState: {
    getPurchases: defaultApiState,
    getPurchase: defaultApiState,
  },
  purchases: [],
  purchase: undefined,
};
